module.exports = __webpack_public_path__ + "static/media/file-edit-alt.1f7a61bc.svg";